<template>
  <div style="height: auto;" v-wechat-title="title">
    <div class="top">
      <div style="margin: 0 10px;display: flex;flex-direction: column;flex:1;">
        <span>{{ addressName }}</span>
        <span style="font-size: 12px;color: #9B9B9B;margin-top: 5px;">设备: {{ deviceId }}</span>
      </div>
      <div style="display: flex;flex-direction: column;align-items: center;"
           @click="$router.push('/device/DeviceOrderRecord')">
        <img :src="require('../../../resource/img/device/svg/xfjl.svg')" style="width: 20px;height: 20px;">
        <span style="font-size: 12px;color: #9B9B9B;margin-right: 10px;">消费记录</span>
      </div>
    </div>
    <div style="width: 100%;height: 64px;"></div>
    <div v-if="isOnline === 1 && isLock === 0" style="margin-top: 10px;">
      <div class="item" v-for="(item, index ) in list" :key="index" @click="itemClick(item)">
        <div v-if="item.isTest == 1" class="experience-tag flag-right">
          体验
        </div>
        <div style="display: flex;flex-direction: column;margin-left:20px;">
          <span style="font-size: 16px;font-weight: bold;">{{ item.name }}</span>
          <span style="color: #9B9B9B;">{{ item.serviceTime }}分钟</span>
        </div>
        <nut-price :price="item.price" style="zoom: 1.5;margin-right: 20px;color: #ff2206;" :decimalDigits="2"
                   :needSymbol="true" :thousands="true"/>
      </div>
      <div style="color: #9B9B9B;width: 100%;text-align: center;height: 30px;line-height: 30px;">如果启动失败，30分钟内会自动退款</div>
      <div style="width: 100%;display: flex;align-items: center;justify-content: center;">
        <nut-checkbox size="small" v-model="serviceCheck" style="color: #9B9B9B;">我已阅读并同意</nut-checkbox>
        <span style="font-size: 14px;" @click="serviceShow = true">《服务协议》</span>
        <nut-dialog title="用户服务声明" :visible="serviceShow" :close-on-click-modal="false" @ok-btn-click="okService"
                    :no-cancel-btn="true" @close="serviceShow=false" :lock-bg-scroll="true" ok-btn-txt="我已阅读并同意">
          <div style="text-align: left;">
            <h4 style="color: #2d2d2d;">为避免发生意外，使用前请仔细阅读本“用户服务声明”，并正确使用。</h4>
            <h4 style="color: #2d2d2d;">不适宜使用本产品的人士</h4>
            <p>1.身体有植入物，如 支架、钢钉、钢板等。</p>
            <p>2.正在接受医生治疗者，特别是身体感到异常者。</p>
            <p>3.患有恶性肿瘤、急性疾病、心脏病、严重高血压等患者。</p>
            <p>4.孕妇或正处于经期者。</p>
            <p>5.严重骨质疏松症、颈椎骨折患者。</p>
            <p>6.静脉血栓患者。</p>
            <p>7.术后未恢复者。</p>
            <p>8.智障人士或未成年人使用时必须有正常人监护下再使用。</p>
            <h4 style="color: #2d2d2d;">禁止事项</h4>
            <p>1.如果发现设备损坏、破裂、漏电以及相关部件暴露出来时，禁止使用。</p>
            <p>2.禁止站立、倒立于设备上或者将其他重物放置、挤压在设备上。</p>
            <p>3.请勿将手指或者其他东西插入设备缝隙中，以免受伤或发生故障。</p>
            <h4 style="color: #2d2d2d;">如果是按摩设备，还需遵守以下事项</h4>
            <p>1.皮肤有创伤的人，不适宜使用按摩设备。</p>
            <p>2.体温38度以上（发热期）的人，不适宜使用按摩设备。</p>
            <p>3.请勿让儿童使用或者在设备上玩耍，请勿让不满12周岁的儿童使用按摩设备。</p>
            <p>4.请勿在设备工作时，在设备上入睡。</p>
            <p>5.请勿在酒醉或身体有其他不适时，使用设备。</p>
          </div>
        </nut-dialog>
      </div>
      <div style="height: 65px;width: 100%;"></div>
    </div>
    <div v-else
         style="display: flex;flex-direction: column; align-items: center;justify-content: center;padding-top: 20%;background: #fff;">
      <template v-if="isOnline == 0">
        <img :src="require('../../../resource/img/device/svg/device_offline.svg')" style="width: 60px;height: 60px;">
        <div style="margin: 10px 0;">设备离线</div>
      </template>
      <template v-if="isOnline == 1 && isLock == 1">
        <img :src="require('../../../resource/img/device/svg/device_open.svg')" style="width: 60px;height: 60px;">
        <div style="margin: 10px 0;">设备正在启动中</div>
      </template>
      <span style="font-size: 12px;color: #9B9B9B;">请尝试线下操作(如果设备支持),或者更换一台设备</span>
      <nut-button shape="circle" style="margin-top: 20px;padding: 0 80px;" @click="qrCode">扫一扫</nut-button>
    </div>
    <div class="bottom">
      <nut-cell>
        <span @click="$router.push('/device/DeviceCustom')" slot="avatar" style="margin: 7px 0;">
          <img class="img-icon"
               :src='user.avatar ? user.avatar : require("@/resource/img/device/headImg.png")'/>
        </span>
        <span slot="title">{{ user.nickname || '用户' }}</span>
        <span
          slot="sub-title">{{ user.uid ? 'uid:' + user.uid : '' }} {{ user.sex === 1 ? '男' : user.sex === 2 ? '女' : '' }}</span>
        <span slot="desc">
          <span>余额: </span>
          <nut-price :price="user.cardMoney" style="color: #ff2206;" :decimalDigits="2"
                     :needSymbol="true" :thousands="true"/>
          <nut-button style="border-radius: 5px;" small @click="$router.push('/device/DeviceRecharge')">充值</nut-button>
        </span>
      </nut-cell>
    </div>
    <pay v-model="payShow" :price="price" :pay-price="payPrice" :data="payData"
         :show-balance="showBalance" :card-money="cardMoney" :show-card="showCard" @payOk="payOkCallback"></pay>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'

/**
 * 设备使用
 */
export default {
  name: 'DeviceUse',
  props: ['deviceId'],
  data() {
    return {
      title: '圣菲机器人',
      imgUrl: sessionStorage.url || require ('../../../Common/common').default.URL,
      //设备是否在线
      isOnline: 1,
      //设备是否锁定
      isLock: 0,
      //是否同意服务条款
      serviceCheck: false,
      //服务条款弹窗
      serviceShow: false,
      user: {},
      config: {},
      //是否显示支付界面
      payShow: false,
      //是否显示余额支付
      showBalance: false,
      //是否显示年卡支付
      showCard: false,
      //金额
      price: 0,
      //应付金额
      payPrice: 0,
      //用户余额
      cardMoney: 0,
      payData: {},
      isLogin: false,
      list: [],
      addressId: null,
      addressName: '',
      webType: '',
    }
  },
  mounted() {
    this.$api.getUrl ().then (url => this.imgUrl = url)
    let device = JSON.parse (localStorage.getItem ('device'))
    if (!this.$util.isArrOrNull (device)) {
      this.addressName = device.addressName
      this.addressId = device.addressId
    }
    localStorage.setItem ('deviceId', this.deviceId)
    this.webType = localStorage.getItem ('webType')
    this.$api.getUser ({ sync: true }).then (res => {
      this.user = res.user
      this.getDevice ()
    }).catch (() => {
      let deviceId = localStorage.getItem ('deviceId')
      this.$router.go (0)
      //this.$router.replace(`/device/DeviceUse?deviceId=${deviceId}`)
    })
  },
  methods: {
    getDevice() {
      this.$api.post ({
        url: '/device/api/device/refresh',
        data: {
          deviceId: this.deviceId
        }
      }).then (res => {
        this.isOnline = res.data.isOnline
        this.isLock = res.data.isLock
        this.getOrder ()
      })
    },
    getOrder() {
      this.$api.post ({
        url: '/device/api/device/order/detail',
        data: {
          merId: this.$api.merId,
          deviceId: this.deviceId,
          uid: this.user.uid,
          paid: 1,
          status: 0
        }
      }).then (res => {
        if (res.data != null) {
          let data = {
            payType: 1,
            orderId: res.data.orderId
          }
          this.$router.push ({
            path: '/device/PayOk',
            query: {
              data: encodeURIComponent (JSON.stringify (data))
            }
          })
        } else {
          if (this.isOnline == 1 && this.isLock == 0) {
            this.serviceShow = true
            this.getData ()
          }
        }
      })
    },
    getData() {
      this.user = this.$api.user
      let data = {
        addressId: this.addressId
      }
      this.$api.post ({
        url: '/device/api/device/device-service/list',
        data: data
      }).then (res => {
        this.list = res.data
      })
    },
    qrCode() {
      if (this.webType == 'weixin') {
        this.$api.post ({
          url: '/seller/api/weixin/weixin-account/config',
          data: {
            agentId: this.$api.agentId,
            signUrl: encodeURIComponent (window.location.href)
          }
        }).then (res => {
          wx.config ({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名，见附录1
            //需要调用的方法接口
            jsApiList: [
              'scanQRCode'
            ]
          })
          wx.ready (() => {
            wx.scanQRCode ({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
              success: res => {

              },
              fail: err => {
                alert (err.errMsg)
                console.log (err)
              }
            })
          })
        })
      } else {
        window.AlipayJSBridge.call ('scan', {
          type: 'qr',
          actionType: 'scanAndRoute'
        }, function (result) {
        })
      }
    },
    itemClick(item) {
      this.config = this.$api.user.configCode === 1 ? this.$api.user.config : {}
      //判断是否已经同意
      if (!this.serviceCheck) {
        this.serviceShow = true
        return
      }
      if (!this.$util.isArrOrNull (this.user.cardMoney) && this.user.cardMoney != 0) {
        this.showBalance = true
        this.cardMoney = this.user.cardMoney
      }
      if (!this.$util.isArrOrNull (this.config.cardId)) {
        let currentTime = this.$util.formatDate.format (new Date (), 'yyyy/MM/dd')
        currentTime = currentTime.replace (/-/g, '/')
        let endTime = this.$util.formatDate.parse (this.config.cardEndTime, 'yyyy/MM/dd')
        endTime = this.$util.formatDate.format (endTime, 'yyyy/MM/dd')
        endTime = endTime.replace (/-/g, '/')
        let current = new Date (currentTime).getTime () / 1000
        let end = new Date (endTime).getTime () / 1000
        if (end >= current) {
          this.showCard = true
        }
      }
      this.price = item.price
      this.payPrice = item.price
      this.payData = {
        agentId: this.$api.agentId,
        merId: this.$api.merId,
        uid: this.user.uid,
        serviceId: item.id,
        deviceId: this.deviceId
      }
      this.payShow = true
    },
    /**
     * 支付成功回调
     * @param res
     */
    payOkCallback(res) {
      this.payShow = false
    },
    okService() {
      this.serviceShow = false
      this.serviceCheck = true
    }
  }
}
</script>

<style scoped>
>>> .nut-dialog-btn:only-child {
  color: #1a87ff;
}

>>> .nut-dialog-ok:active {
  background: #1a87ff;
  color: white;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  background-color: #fff;
  height: 45px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
  border-bottom: #d3d3d3 solid 0.5px;
}

.item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 10px;
  padding: 15px 0;
  background-color: white;
  border-radius: 5px;
  overflow: hidden;
}

.item .experience-tag {
  position: absolute; /*绝对定位*/
  osition: absolute;
  height: 20px;
  line-height: 20px;
  text-align: center;
  width: 62px;
  background-color: #FF5722;
  color: #fff;
}

.item .flag-right {
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  right: -15px;
  top: 5px;
}

.bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
}

.bottom .img-icon {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-right: 5px;
  border: 1px solid rgba(211, 211, 211, 0.35);
}
</style>



// WEBPACK FOOTER //
// src/components/device/use/DeviceUse.vue